import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";

export const getProtectionZoneFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    aImediata: numberField.optional(),
    pImediata: numberField.optional(),
    outrasCaptImediata: z.string().max(255).nullable().optional(),
    snAimediata: z.boolean().default(false),
    estado: z.string().max(255).nullable().optional(),

    rede: z.boolean().default(false),
    placa: z.boolean().default(false),
    nPlaca: numberField.optional(),

    aIntermedia: numberField.optional(),
    outrasCaptIntermedia: z.string().max(255).nullable().optional(),

    aAlargada: numberField.optional(),
    outrasCaptAlargada: z.string().max(255).nullable().optional(),

    precoRede: numberField.optional(),
    precoPilaretes: numberField.optional(),
    precoPlaca: numberField.optional(),
  });
};

export type ProtectionZoneForm = z.infer<ReturnType<typeof getProtectionZoneFormSchema>>;